export const PrivacyPolicyData = [
  {
    description_1:
      "FORBIT is one of the rising company for software and IOT based services in Bangladesh offer by some young entrepreneurs. As part of our services we built the SultanTracker app as a Free app. This SERVICE is provided by FORBIT at no cost and is intended for use as is.",
    description_2:
      "This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.",
    description_3:
      "SultanTracker is a GPS Tracking Service using GPS Tracking Devices installed in vehicles or used by the customer for monitoring their concerned Physical Assets. This App or application is used for Tracking the physical devices only, and the data collected through the physical device. Only the customers and or owners of these IOT devices and or assets will be able to use this service for their Asset Tracking purposes. This is the domain of the service of this Application.",
  },

  {
    title: "How We Collect and Use Information",
    description_1:
      "We collect the following types of information about you:\n\n\n" +
      "Registration and Profile Information:\n" +
      "When you create an account and during the use of the service, we may collect your personal information such as your username, first and last name, email address, and mobile phone number. After setting up your account, we may also request other profile and demographic information such as your organization name, address, phone number, and city.",

    description_2:
      "📸 Camera Permission :\n\n" +
      "Why We Collect:\n" +
      "We request access to your device's camera to:\n" +
      "- Capture your profile photo.\n" +
      "- Capture vehicle photos for registration/verification.\n" +
      "- Capture driver photos for identification and security.\n\n" +
      "How It’s Used:\n" +
      "Photos are used within the app for verification and record-keeping. We do NOT share these images with third parties without your consent.",

    description_3:
      "📍 Location Permission : (Geolocation)\n\n" +
      "Why We Collect:\n" +
      "We collect your location data to:\n" +
      "- Show your current location on the map.\n" +
      "- Calculate the distance between your phone and your vehicle’s GPS tracker.\n" +
      "- Improve app functionality by providing accurate location-based services.\n\n" +
      "How It’s Used:\n" +
      "Location data is used in real-time only while the app is running. We do not store or share your location unless required by law or with your consent.",

    description_4:
      "💬 Messages Permission :\n\n" +
      "Why We Collect:\n" +
      "We enable message functionality so that you can:\n" +
      "- Send specific commands from your phone to connected physical devices (like GPS trackers).\n\n" +
      "How It’s Used:\n" +
      "Commands are transmitted only between your app and the authorized device. They are not shared with any third parties.",

    description_5:
      "📞 Phone Call Permission (CALL_PHONE)\n\n" +
      "Why We Collect:\n" +
      "We request permission to make phone calls so that you can:\n" +
      "- Directly call the driver from within the app for convenience and safety.\n\n" +
      "How It’s Used:\n" +
      "We only use this permission when you choose to initiate a call to your driver. We do not make any calls without your action or access your call logs.",

    description_6:
      "🛠️ Storage Permission :\n\n" +
      "We use all collected information to operate, maintain, and provide the features and functionality of the Service. This includes:\n" +
      "- Sending alerts on movements of your vehicles or assets.\n" +
      "- Allowing you to control alerts through app settings.\n" +
      "- Sending service-related emails (e.g., verification, updates, technical notices) related only to services you have opted for.",
  },
  {
    title: "Sharing of Your Information",
    description_1:
      "We share your personal information, including name, email, and location with others only within the organization or group used in SultanTracker services.",
    description_2:
      "We may at any time buy or sell/divest the company, or any combination of its products, services, assets and/or businesses. Personal information such as customer names and email addresses, and other user information related to the Service will likely be one of the items transferred in these types of transactions. We may also share, transfer or assign such information in the course of corporate divestitures, mergers, acquisitions, bankruptcies, dissolutions or similar transactions or proceedings. Except as described above, we will not disclose personal information to third parties (including law enforcement, other government entity, or civil litigant; excluding our subcontractors) unless required to do so by law or subpoena or if in our sole discretion, we determine it is necessary to (a) conform to the law, comply with legal process, or investigate, prevent, or take action regarding suspected or actual illegal activities; (b) to enforce our Terms of Use, take precautions against liability, to investigate and defend ourselves against any claims or allegations, or to protect the security or integrity of our site; and/or (c) to exercise or protect the rights, property, or personal safety of FORBIT, our Users or others.",
  },
  {
    title: "How We Protect Your Information",
    description_1:
      "FORBIT cares about the security of your information and uses commercially reasonable physical, administrative, and technological safeguards to preserve the integrity and security of all information we collect and that we share with our service providers. However, no security system is impenetrable and we cannot guarantee the security of our systems 100%. In the event that any information under our control is compromised as a result of a breach of security, we will take reasonable steps to investigate the situation and where appropriate, notify those individuals whose information may have been compromised and take other steps, in accordance with any applicable laws and regulations. FORBIT maintains proper backup of your data, but not everything or related data can be guaranteed, so if upon any unforeseeable reason the data backups fail then FORBIT will notify the user but cannot do anything more than that.",
  },
  {
    title: "Data Security",
    description_1:
      "we value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.",
  },
  {
    title: "No Data Selling Policy",
    description_1:
      "We do NOT sell, trade, or rent your personal data to any third parties. Your privacy is important to us.",
  },
  {
    title: "Links to Other Sites",
    description_1:
      "This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. we have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.",
  },
  {
    title: "Children’s Privacy",
    description_1:
      "These Services do not address anyone under the age of 13. we do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.",
  },
  {
    title: "Changes to This Privacy Policy",
    description_1:
      "We may update this Privacy Policy from time to time. Any changes will be posted within the app or on our website.",
  },
  {
    title: " Third-Party Services",
    description_1:
      "We may use third-party services that have their own privacy policies. We encourage you to review their policies if used within the app.",
  },
  {
    title: "Your Privacy Rights as in Bangladesh",
    description_1:
      "FORBIT collects various types of personal information about you both online and offline, as described in this privacy policy. Under the law of Bangladesh, FORBIT customers who are residents of Bangladesh or we the service of FORBIT, may have to disclose their data or information till the last available or retained data to third parties including government entities according to the law of the land as required. We will comply with such request which will be applicable based on the law of the country.",
  },

  {
    title: "Contact Us",
    description_1:
      "If you have any questions or concerns about this Privacy Policy, please contact us at:",
    description_2: "Email: admin@forbit.tech",
    description_3: "Company Name: Forbit Limited",
  },
];
